import { Children, Fragment, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Accordion, AccordionHeader, Box, Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
const MAX_CHILDREN = 3;
export function RecipientsAccordion(props) {
    const { title, children, endElement, hideTooManyItems = false } = props;
    const [showAll, setShowAll] = useState(false);
    const toggleShowAll = () => setShowAll((value) => !value);
    const childArray = Children.toArray(children);
    const childAmount = childArray.length;
    const strippedChildren = childArray.filter((_, index) => index < MAX_CHILDREN);
    const useNestedLayout = hideTooManyItems && childAmount > MAX_CHILDREN;
    return (<Accordion header={<AccordionHeader icon={<Falcon icon="users"/>} title={title} endElement={endElement}/>}>
      {useNestedLayout ? (<Fragment>
          {showAll ? children : strippedChildren}
          <Box mt="md" width="100%" justifyContent="center">
            <Button size="xs" appearance="ghost" onClick={toggleShowAll}>
              {showAll ? (<Fragment>
                  <Trans comment="Signatory accordion list showing all signing parties - Show less call to action button label">
                    Show less
                  </Trans>
                  <Falcon icon="chevron-up"/>
                </Fragment>) : (<Fragment>
                  <Trans comment="Signatory accordion list showing a few signing parties - Show all call to action button label">
                    Show all ({childAmount})
                  </Trans>
                  <Falcon icon="chevron-down"/>
                </Fragment>)}
            </Button>
          </Box>
        </Fragment>) : (children)}
    </Accordion>);
}
